import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { useFeatures } from '@/contexts/root-store-context'
import { useDocumentTitle } from '@/hooks/document-title'

/**
 * Layout for the payouts admin pages. Admin mounts it behind its own
 * permission check.
 */
export default observer(function PayoutsAdminContainer() {
  const { payouts } = useFeatures((r) => ({ payouts: r.payouts.internal() }))
  useDocumentTitle('Payouts')

  return payouts.payoutsAdminViewModel ? (
    <Outlet context={payouts.payoutsAdminViewModel} />
  ) : null
})
